<template>
  <div>
    <top-ad></top-ad>
    <top-nav></top-nav>
    <div class="middle">
      <div class="middle_center">
        <router-link :to="{name: 'index'}">
          <img class="logo"
               :src="logo">
        </router-link>
        <!--  搜索部分 -->
        <div class="search_box ">
          <div class="search_con back_primary">
            <span>服务市场</span>
          </div>
          <div class='search_info'>
            <Input v-model="searchName"
                   placeholder="关键词" />
            <router-link :to="{path: '/service/SearchService', query: {keyWord: searchName}}"
                         class="search_logo back_primary">搜索
            </router-link>
          </div>
        </div>
      </div>
      <ul class="my_nav">
        <li>
          <router-link :class="this.$route.name === 'index'? 'primary':''"
                       :to="{name: 'index'}">商城首页
          </router-link>
        </li>
        <li>
          <router-link :class="this.$route.name === 'serviceMarket'? 'primary':''"
                       :to="{name: 'serviceMarket'}">服务市场
          </router-link>
        </li>
        <li>
          <router-link :class="this.$route.name === 'serviceBusinesses'? 'primary':''"
                       :to="{name: 'serviceBusinesses'}">逛商家
          </router-link>
        </li>
        <li v-for="(item,index) in list"
            :key="index">
          <router-link :class="$route.query.categoryName === item.categoryName? 'primary':''"
                       :to="{path: '/service/serviceCategory', query:{ categoryId: item.id, categoryName: item.categoryName}}">
            {{item.categoryName}}
          </router-link>
        </li>
        <li @click="goServiceAdmin">服务商入口</li>
      </ul>
    </div>
    <router-view></router-view>
    <Footer></Footer>
  </div>
</template>

<script>
import TopAd from '@/layout/components/Header/TopAd'
import TopNav from '@/layout/components/Header/TopNav'
import Footer from '@/layout/components/Footer'
import { getServiceCategory } from '@/api/service'

export default {
  name: 'index',
  components: {
    TopAd,
    TopNav,
    Footer
  },
  data() {
    return {
      logo: require('@/assets/images/LOGO.png'),
      searchName: null,
      list: []
    }
  },
  mounted() {
    this.getServiceCategory()
    if (this.$store.state.mallLogo) {
      this.logo = this.$store.state.mallLogo
    }
  },
  methods: {
    getServiceCategory() {
      getServiceCategory().then(res => {
        this.list = res.data
      })
    },
    goServiceAdmin() {
      window.open(this.ADMIN_URL + '/#/ispLogin?t=' + this.$store.state.token, '_blank')
    }
  }
}
</script>

<style lang="less" scoped>
.middle {
  width: 100%;
  padding: 30px 0 0;
}

.middle .middle_center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin: 0 auto;
  width: 1200px;
  margin-bottom: 30px;

  .logo {
    width: 179px;
    margin-right: 34px;
  }
}

.search_box {
  /*width: 560px;*/
  text-align: left;
}

.search_con {
  font-size: 12px;
  cursor: pointer;
  line-height: 26px;
  text-align: center;
  background: #f0f0f0;
  width: 60px;
  height: 26px;
  border-radius: 4px 4px 0 0;
}

.search_info {
  width: 480px;
  margin-right: 20px;
  display: flex;
  align-items: center;
}

.search_logo {
  width: 56px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0 4px 4px 0;
}

.my_nav {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  align-items: center;

  li {
    min-width: 95px;
    height: 30px;
    line-height: 30px;
    font-size: 14px;
    padding: 0 10px;
  }
}
</style>
